import type { IUser } from '@board/shared/model/user';

import { LoadableComponent } from '@board/ui/LoadableComponent';
import React from 'react';

const Component = React.lazy(() => import('./PrivateRoutes'));

export const PrivateRoutes = ({ user }: { user: IUser }) => (
  <LoadableComponent>
    <Component user={user} />
  </LoadableComponent>
);
